<template>
  <div class="flex flex-col min-h-full divide-y">
    <div class="px-6 py-4">
      <span class="uppercase text-xs font-semibold tracking-wider text-gray-600">Order Item</span>
      <h6>
        {{ orderItem.name }}
      </h6>
    </div>
    <div class="flex-1 divide-y">
      <div class="divide-y">
        <div class="px-6 py-4 flex justify-between items-center">
          <h5 class="uppercase font-semibold text-base text-gray-800">Specs</h5>
        </div>
        <div class="px-6 py-4">
          <pre
            v-if="orderItem.requirements"
            class="whitespace-pre-wrap"
            v-text="orderItem.requirements"
          />
          <span v-else class="text-teal-600">No specifications</span>
        </div>
      </div>
      <div class="divide-y">
        <div class="px-6 py-4 flex justify-between items-center">
          <h5 class="uppercase font-semibold text-base text-gray-800">Links</h5>
        </div>

        <ul class="grid grid-cols-2 gap-4 p-4 bg-white">
          <template v-if="links.length">
            <li v-for="link in links" :key="link.id">
              <OrderItemDetailsLinkAttachment :link="link" />
            </li>
          </template>
          <li v-else class="px-2">
            <span class="text-teal-600">No Links </span>
          </li>
        </ul>
      </div>
      <div class="divide-y">
        <div class="px-6 py-4 flex justify-between items-center">
          <h5 class="uppercase font-semibold text-base text-gray-800">Notes</h5>
        </div>

        <ul class="divide-y">
          <template v-if="notes.length">
            <li
              v-for="note in notes"
              :key="note.id"
              class="px-6 pt-4 pb-6 hover:bg-gray-100 select-none space-y-4"
            >
              <p class="text-gray-800">
                {{ note.content }}
              </p>
            </li>
          </template>
          <li v-else class="px-6 py-4">
            <span class="text-teal-600">No Notes </span>
          </li>
        </ul>
      </div>
      <div class="divide-y">
        <div class="px-6 py-4 flex justify-between items-center">
          <h5 class="uppercase font-semibold text-base text-gray-800">Media</h5>
        </div>

        <ul class="grid grid-cols-2 gap-4 p-4 bg-white">
          <template v-if="media.length">
            <li v-for="medium in media" :key="medium.id">
              <OrderItemDetailsMediaAttachment :media="medium" />
            </li>
          </template>
          <li v-else class="px-2">
            <span class="text-teal-600">No Media </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OrderItemDetailsLinkAttachment from './order-item-details-link-attachment.vue';
import OrderItemDetailsMediaAttachment from './order-item-details-media-attachment.vue';

export default {
  components: {
    OrderItemDetailsLinkAttachment,
    OrderItemDetailsMediaAttachment,
  },
  props: {
    orderItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', {
      links({ links: { byId: linksById } }) {
        return this.orderItem.links.map((linkId) => linksById[linkId]);
      },
      notes({ notes: { byId: notesById } }) {
        return this.orderItem.notes.map((noteId) => notesById[noteId]);
      },
      media({ media: { byId: mediaById } }) {
        return this.orderItem.media.map((mediaId) => mediaById[mediaId]);
      },
    }),
  },
};
</script>
